import type { ChangeEvent } from 'react'
import React from 'react'

import './PriceRangeBox.scss'
import type { PriceRangeBoxProps } from '../../types/components/PriceRangeBox'
import type { RangePrice } from '../../types/components/PriceRange'

export default function PriceRangeBox({
  min,
  max,
  arrayPriceRange,
  selectedFacets,
  setMinPriceSelected,
  setMaxPriceSelected,
  setMinValuePlaceHolder,
  setMaxValuePlaceHolder,
}: PriceRangeBoxProps) {
  const isPriceRangeAlreadyFiltered = (rangePrice: RangePrice): boolean => {
    let isAlreadyFiltered = false

    for (const facet of selectedFacets) {
      if (
        facet?.key === 'price' &&
        facet?.value ===
          `${
            rangePrice?.minValue < min?.absolute
              ? min?.absolute
              : rangePrice?.minValue
          }-to-${
            rangePrice?.maxValue > max?.absolute
              ? max?.absolute
              : rangePrice?.maxValue
          }`
      ) {
        isAlreadyFiltered = true
        break
      }
    }

    return isAlreadyFiltered
  }

  const shouldRangeBeRendered = (rangePrice: RangePrice): boolean => {
    if (
      isPriceRangeAlreadyFiltered(rangePrice) ||
      rangePrice?.maxValue < min?.absolute ||
      rangePrice?.minValue > max?.absolute
    ) {
      return false
    }

    return true
  }

  function handleChange(
    value: RangePrice,
    event: ChangeEvent<HTMLInputElement>
  ) {
    uncheckAllPriceCheckboxes()
    event.target.checked = true

    if (value?.minValue < min?.absolute) {
      value.minValue = min.absolute
    }

    if (value?.maxValue > max?.absolute) {
      value.maxValue = max.absolute
    }

    setMinPriceSelected(value?.minValue)
    setMinValuePlaceHolder(value?.minValue)
    setMaxPriceSelected(value?.maxValue)
    setMaxValuePlaceHolder(value?.maxValue)
  }

  return (
    <div className="accordion--Price-Range">
      <ul className="ul--Price-Range">
        {arrayPriceRange?.map(
          (range: RangePrice, index: number) =>
            shouldRangeBeRendered(range) && (
              <li
                key={index}
                className={`filter__item li--Price-Range ${range?.title}`}
              >
                <input
                  className="checkbox__inner-container"
                  type="checkbox"
                  data-fs-checkbox="true"
                  id={range?.title}
                  value={index}
                  onChange={(event) => handleChange(range, event)}
                />
                <label className="labelRange--Price-Range">
                  {range?.title}
                </label>
              </li>
            )
        )}
      </ul>
    </div>
  )
}

function getPriceCheckboxes() {
  return Array.from(
    document.getElementsByClassName('checkbox__inner-container')
  ) as HTMLInputElement[]
}

export function uncheckAllPriceCheckboxes() {
  const checkboxes = getPriceCheckboxes()

  checkboxes?.forEach((input: HTMLInputElement) => {
    input.checked = false
  })
}
